"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function HeroSection() {
  const { t } = useLanguage();
  return (
    <section className="bg-[#fefce8] py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-[900px] mx-auto text-center">
        <h1 className="text-3xl md:text-[42px] font-black text-[#064e3b] leading-tight mb-6">
          {t("access.h1")}
        </h1>
        <p className="text-base md:text-lg text-[#374151] max-w-3xl mx-auto leading-relaxed mb-4">
          {t("access.intro")}
        </p>
        <p className="text-sm text-[#374151]/70 italic">
          {t("access.lastUpdated")}
        </p>
      </div>
    </section>
  );
}